import { Component, ChangeDetectionStrategy, inject, effect } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { HeroComponent } from './components/hero/hero.component';
import { AboutComponent } from './components/about/about.component';
import { ServicesComponent } from './components/services/services.component';
import { SafetyComponent } from './components/safety/safety.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { CareerComponent } from './components/career/career.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { StatsComponent } from './components/stats/stats.component';
import { ContactComponent } from './components/contact/contact.component';
import { FooterComponent } from './components/footer/footer.component';
import { CompanyLifeComponent } from './components/company-life/company-life.component';
import { SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent,
    HeroComponent,
    AboutComponent,
    ServicesComponent,
    SafetyComponent,
    GalleryComponent,
    CompanyLifeComponent,
    CareerComponent,
    TestimonialsComponent,
    StatsComponent,
    ContactComponent,
    FooterComponent
  ]
})
export class AppComponent {
  private seoService = inject(SeoService);

  constructor() {
    effect(() => {
      this.seoService.updateMetaTags();
    });
  }
}